import { useEffect } from 'react';

/* `data-public` on <html> takes every themed rule out of play while an OUTSIDER
   is on screen.
 *
 * Why it is needed: ThemeContext writes the signed-in staff member's theme onto
 * the root element, and defaults ANY visitor — including an anonymous candidate
 * — to the light "daylight" group. The Daylight accent sweep is scoped to
 * `[role="dialog"]`, which reaches Radix portals, so a public dialog was being
 * repainted in the internal ATS teal. Worse, the tinted-fill rule matches on the
 * class ATTRIBUTE, so a `hover:bg-violet-500/5` class applied its tint
 * permanently.
 *
 * A counter, not a boolean: during a route change React can run the OUTGOING
 * page's cleanup after the incoming page's effect, which would strip the
 * attribute off the page that just asked for it. */
let holders = 0;

/** @param kind 'token' for the pages we email a candidate (pinned light), or
 *  'marketing' for the public site (its own dark palette). Portalled dialogs
 *  have no ancestor to read, so the value is how CSS tells them apart. */
export function usePublicSurface(kind = 'marketing') {
  useEffect(() => {
    holders += 1;
    document.documentElement.setAttribute('data-public', kind);
    return () => {
      holders -= 1;
      if (holders <= 0) {
        holders = 0;
        document.documentElement.removeAttribute('data-public');
      }
    };
  }, [kind]);
}

export default usePublicSurface;
